export enum UiWindow
{
    ExtraStatistics = 1,
    VerifyResults = 2,
    GraphicSimulation = 3
}